module.exports = __webpack_public_path__ + "img/family_disabled.ab6da2d3.svg";